import React, { useState, useEffect } from "react";
import { useFeira } from "../Contexts/FeiraContext";
import 'swiper/css';
import 'swiper/css/navigation';
import { motion, AnimatePresence } from "framer-motion";
import ModalDeReserva from "./ModalDeReserva";
import ModalQueroExpor from "./ModalQueroExpor";
import ModalRenovacao from "./ModalRenovacao";
import ModalAviso from "../Components/Common/ModalAviso";
import "../assets/scss/vendas/vendas.scss";
import SidebarFeiraNovo from "./SidebarMapa/SidebarFeiraNovo";
import SidebarEstandeVendidoNovo from "./SidebarMapa/SidebarEstandeVendidoNovo";
import SidebarEstandeReservadoNovo from "./SidebarMapa/SidebarEstandeReservadoNovo";
import SidebarEstandePadraoNovo from "./SidebarMapa/SidebarEstandePadraoNovo";
import SidebarEstandeRenovacaoNovo from "./SidebarMapa/SidebarEstandeRenovacaoNovo";
import { useLocation } from "react-router-dom";

const SidebarEstande = () => {
  const {
    whatsappPrincipal,
    nomeFeira,
    openModalWhatsapp,
    selectedEstandeInfo,
    setSelectedEstandeInfo,
    setOpenModal,
    data,
    loading,
    error,
    corPrincipal,
    corSecundaria,
    setOpenModalWhatsapp,
    isMobile,
    openMobile,
    setOpenMobile,
    mensagemPadrao,
    setOpenModalQueroExpor,
    idFeira,
    modoRenovacao,
    setOpenModalRenovacao,
    emailRenovacao,
    setOpenModalRenovacaoReserva,
    exibirAviso,
    configuracao,
    openModal,
    openModalRenovacao,
    openModalRenovacaoReserva

  } = useFeira();

  const location = useLocation();

  // Ajuste aqui se tua rota interna real for diferente
  const isVisualizacaoInterna =
    location.pathname.startsWith("/mapa-interno") ||
    location.pathname.startsWith("/mapa-vendas");

  // Regra central:
  // desktop externo = fixed
  // todo o resto = modal
  const presentationMode =
    !isMobile && !isVisualizacaoInterna ? "fixed" : "modal";

  const [swiperKey, setSwiperKey] = useState(0);

  useEffect(() => {
    setSwiperKey((prev) => prev + 1);
  }, [selectedEstandeInfo?.imagens]);

  useEffect(() => {
    // No mobile externo, mantém as informações da feira fechadas ao carregar.
    // Elas só serão abertas quando o usuário tocar no botão flutuante.
    if (isMobile && !isVisualizacaoInterna) {
      setOpenMobile(false);
    }
  }, [isMobile, isVisualizacaoInterna, setOpenMobile]);

  const closeModal = () => {
    setOpenMobile(false);
    setSelectedEstandeInfo(null);
  };

  const isInfoFeiraOpen =
    presentationMode === "modal" &&
    !isVisualizacaoInterna &&
    openMobile &&
    !selectedEstandeInfo;

  const isEstandeOpen = !!selectedEstandeInfo;
  const hasModalReservaOuRenovacaoAberto = openModal || openModalRenovacao || openModalRenovacaoReserva;

  // const isModalOpen = presentationMode === "modal" && (isInfoFeiraOpen || isEstandeOpen);
  //const isModalOpen = presentationMode === "modal" && !hasModalReservaOuRenovacaoAberto && (isInfoFeiraOpen || isEstandeOpen);
  const isModalOpen = presentationMode === "modal" && (isInfoFeiraOpen || isEstandeOpen);
  // const isModalOpen =
  // presentationMode === "modal" &&
  // !hasModalReservaOuRenovacaoAberto &&
  // (isInfoFeiraOpen || isEstandeOpen);

  const renderView = () => {
    if (loading) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h3>Carregando dados da feira...</h3>
        </div>
      );
    }

    if (error || !data?.retorno) {
      return (
        <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
          <h3>Erro ao carregar os dados da feira.</h3>
          <p>{error || "Dados não encontrados."}</p>
        </div>
      );
    }

    // SEM estande selecionado
    if (!selectedEstandeInfo) {
      // desktop externo -> sidebar fixa mostra informações da feira
      if (presentationMode === "fixed") {
        return (
          <SidebarFeiraNovo
            data={data}
            corPrincipal={corPrincipal}
            corSecundaria={corSecundaria}
            isMobile={isMobile}
            setOpenMobile={setOpenMobile}
            whatsappPrincipal={whatsappPrincipal}
            nomeFeira={nomeFeira}
            mensagemPadrao={mensagemPadrao}
            setOpenModalQueroExpor={setOpenModalQueroExpor}
            idFeira={idFeira}
            isVisualizacaoInterna={isVisualizacaoInterna}
          />
        );
      }

      // mobile externo -> só mostra a feira quando o usuário abrir o modal
      if (presentationMode === "modal" && isInfoFeiraOpen) {
        return (
          <SidebarFeiraNovo
            data={data}
            corPrincipal={corPrincipal}
            corSecundaria={corSecundaria}
            isMobile={isMobile}
            setOpenMobile={setOpenMobile}
            whatsappPrincipal={whatsappPrincipal}
            nomeFeira={nomeFeira}
            mensagemPadrao={mensagemPadrao}
            setOpenModalQueroExpor={setOpenModalQueroExpor}
            idFeira={idFeira}
            isVisualizacaoInterna={isVisualizacaoInterna}
          />
        );
      }

      return null;
    }

    if (modoRenovacao) {
      if (selectedEstandeInfo?.status_reserva_id === 6) {
        return (
          <SidebarEstandeRenovacaoNovo
            selectedEstandeInfo={selectedEstandeInfo}
            setSelectedEstandeInfo={setSelectedEstandeInfo}
            corPrincipal={corPrincipal}
            corSecundaria={corSecundaria}
            isMobile={isMobile}
            setOpenMobile={setOpenMobile}
            setOpenModal={setOpenModal}
            whatsappPrincipal={whatsappPrincipal}
            nomeFeira={nomeFeira}
            mensagemPadrao={mensagemPadrao}
            openModalWhatsapp={openModalWhatsapp}
            setOpenModalWhatsapp={setOpenModalWhatsapp}
            setOpenModalRenovacao={setOpenModalRenovacao}
            setOpenModalRenovacaoReserva={setOpenModalRenovacaoReserva}
            emailRenovacao={emailRenovacao}
            exibirAviso={exibirAviso}
            configuracao={configuracao}
            isVisualizacaoInterna={isVisualizacaoInterna}
          />
        );
      }

      if (selectedEstandeInfo?.status_reserva_id === 5) {
        return (
          <SidebarEstandeVendidoNovo
            selectedEstandeInfo={selectedEstandeInfo}
            corPrincipal={corPrincipal}
            corSecundaria={corSecundaria}
            isMobile={isMobile}
            setOpenMobile={setOpenMobile}
            label="(Renovado)"
            isVisualizacaoInterna={isVisualizacaoInterna}
          />
        );
      }
    }

    if (selectedEstandeInfo?.status_reserva_id === 3) {
      return (
        <SidebarEstandeVendidoNovo
          selectedEstandeInfo={selectedEstandeInfo}
          corPrincipal={corPrincipal}
          corSecundaria={corSecundaria}
          isMobile={isMobile}
          setOpenMobile={setOpenMobile}
          label="(Vendido)"
          isVisualizacaoInterna={isVisualizacaoInterna}
        />
      );
    }

    if (selectedEstandeInfo?.status_reserva_id === 2) {
      return (
        <SidebarEstandeReservadoNovo
          selectedEstandeInfo={selectedEstandeInfo}
          setSelectedEstandeInfo={setSelectedEstandeInfo}
          corPrincipal={corPrincipal}
          corSecundaria={corSecundaria}
          isMobile={isMobile}
          setOpenMobile={setOpenMobile}
          isVisualizacaoInterna={isVisualizacaoInterna}
        />
      );
    }

    return (
      <SidebarEstandePadraoNovo
        selectedEstandeInfo={selectedEstandeInfo}
        setSelectedEstandeInfo={setSelectedEstandeInfo}
        corPrincipal={corPrincipal}
        corSecundaria={corSecundaria}
        isMobile={isMobile}
        setOpenMobile={setOpenMobile}
        setOpenModal={setOpenModal}
        whatsappPrincipal={whatsappPrincipal}
        nomeFeira={nomeFeira}
        mensagemPadrao={mensagemPadrao}
        openModalWhatsapp={openModalWhatsapp}
        setOpenModalWhatsapp={setOpenModalWhatsapp}
        exibirAviso={exibirAviso}
        isVisualizacaoInterna={isVisualizacaoInterna}
      />
    );
  };

  

  return (
    <React.Fragment>
      {/* BOTÃO FLUTUANTE:
          somente no modal externo mobile, quando não tem nada aberto */}
      {presentationMode === "modal" &&
        isMobile &&
        !isVisualizacaoInterna &&
        !isModalOpen && (
          <button
            onClick={() => {
              setSelectedEstandeInfo(null);
              setOpenMobile(true);
            }}
            style={{
              position: "fixed",
              bottom: "20px",
              left: "20px",
              zIndex: 1999,
              backgroundColor: corPrincipal,
              color: "#fff",
              border: "none",
              borderRadius: "30px",
              padding: "10px 16px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px"
            }}
          >
            <i className="ri-information-line" style={{ fontSize: "18px" }}></i>
            Ver informações da feira
          </button>
        )}

      {/* DESKTOP EXTERNO */}
      {presentationMode === "fixed" && (
        <aside className="sidebar">
          <AnimatePresence mode="wait">
            <div key={selectedEstandeInfo?.id || "sidebar-feira"}>
              {renderView()}
            </div>
          </AnimatePresence>
        </aside>
      )}

      {/* MODAL: mobile externo + interno desktop/mobile */}
      {presentationMode === "modal" && (
        <AnimatePresence>
          {isModalOpen && (
            <>
              <motion.div
                className="sidebar-backdrop-unificado"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={closeModal}
              />

              <motion.aside
                className={`sidebar-modal-unificado ${isMobile ? "is-mobile" : "is-desktop"}`}
                initial={isMobile ? { y: 80, opacity: 0 } : { x: 420, opacity: 0 }}
                animate={isMobile ? { y: 0, opacity: 1 } : { x: 0, opacity: 1 }}
                exit={isMobile ? { y: 80, opacity: 0 } : { x: 420, opacity: 0 }}
                transition={{ duration: 0.25 }}
              >
                <AnimatePresence mode="wait">
                  <div key={selectedEstandeInfo?.id || (isInfoFeiraOpen ? "sidebar-feira-modal" : "sidebar-empty")}>
                    {renderView()}
                  </div>
                </AnimatePresence>
              </motion.aside>
            </>
          )}
        </AnimatePresence>
      )}

      <ModalDeReserva />
      <ModalQueroExpor idFeira={idFeira} />
      <ModalAviso />

      {modoRenovacao && selectedEstandeInfo?.status_reserva_id === 6 && (
        <ModalRenovacao />
      )}
    </React.Fragment>
  );
};

export default SidebarEstande;